<template>
  <div class="login-bg">
    <div class="bg-image"></div>
    <div class="bg-blur"></div>

    <div class="login-card">
      <!-- HEADER -->
      <div class="login-header">
        <!-- <img src="/static/login-logo.png" class="login-logo" alt="Logo" /> -->

        <div class="logo-animated">
          <img
            src="/static/login-logo.png"
            alt="BRweb Logo"
            class="logo-img"
          />
          <span class="logo-shine"></span>
        </div>

        <!-- APP INFO -->
        <div class="app-info">
          <div class="app-name">
            {{ appName }}
          </div>

          <div class="app-meta">
            <span class="app-version">v{{ appVersion }}</span>
            <span v-if="isDev" class="app-dev">DEV</span>
          </div>
        </div>
      </div>

      <!-- WELCOME -->
      <!-- <transition name="fade-slide" mode="out-in">
        <div class="login-welcome" :key="welcomeText">
          {{ welcomeText }}
        </div>
      </transition> -->

      <!-- FORM -->
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        class="login-form"
      >
        <Form-item prop="username">
          <Input v-model="formInline.username" placeholder="Username" size="large">
            <Icon type="ios-person-outline" slot="prepend" />
          </Input>
        </Form-item>

        <Form-item prop="password">
          <Input
            type="password"
            v-model="formInline.password"
            placeholder="Password"
            size="large"
            @on-enter="handleSubmit('formInline')"
          >
            <Icon type="ios-locked-outline" slot="prepend" />
          </Input>
        </Form-item>

        <Form-item>
          <Button
            class="login-btn"
            long
            :loading="loadingLogin"
            icon="log-in"
            @click="handleSubmit('formInline')"
          >
            <span v-if="!loadingLogin">Login</span>
            <span v-else>Authenticating...</span>
          </Button>
        </Form-item>
      </Form>

      <!-- FOOTER -->
      <!-- <div class="login-footer">
        {{ serverIP }}
      </div> -->
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'

const lastUsername = localStorage.getItem('lastUsername')
const serverIP = localStorage.getItem('serverIP')
const appVersion = localStorage.getItem('appVersion')
const appName = localStorage.getItem('appName')

export default {
  data () {
    return {
      serverIP,
      appVersion,
      appName,
      loadingLogin: false,
      welcomeText: 'Welcome Back 👋',
      formInline: {
        username: lastUsername || '',
        password: ''
      },
      ruleInline: {
        username: [
          { required: true, message: 'Masukkan Username', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Masukkan Password', trigger: 'blur' },
          { type: 'string', min: 3, message: 'Minimal 3 karakter', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    isDev () {
      return (
        _.includes(this.serverIP, 'localhost') ||
        _.includes(this.serverIP, '127.0.0.1') ||
        _.includes(this.serverIP, '8.214.64.22:8082') ||
        _.includes(this.serverIP, 'dev-api.blueray-cargo.com')
      )
    }
  },

  mounted () {
    this.rotateWelcomeText()
  },

  methods: {
    rotateWelcomeText () {
      const messages = [
        'Welcome Back 👋',
        'Semoga harimu produktif ✨',
        'Siap bekerja hari ini? 🚀',
        'Let’s make today great 🔥',
        'Good to see you again 😊'
      ]
      let i = 0
      setInterval(() => {
        this.welcomeText = messages[i % messages.length]
        i++
      }, 4000)
    },

    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) this.postLogin()
      })
    },

    postLogin () {
      this.loadingLogin = true
      HTTP.post('auth/login', {
        username: this.formInline.username,
        password: this.formInline.password
      })
        .then(res => {
          const token = res.data.data.token
          localStorage.setItem('access_token', token)
          localStorage.setItem('lastUsername', this.formInline.username)
          HTTP.defaults.headers.common.Authorization = `Bearer ${token}`
          this.formInline.password = ''
          this.$emit('setIsLoggedIn', true)
        })
        .finally(() => {
          this.loadingLogin = false
        })
    }
  }
}
</script>

<style scoped>
/* BACKGROUND */
.login-bg {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9, #e2e8f0);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.bg-image {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(
      135deg,
      rgba(15,23,42,.75),
      rgba(30,41,59,.65)
    ),
    url('/static/bg-logistics.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
}

.bg-blur {
  position: absolute;
  width: 420px;
  height: 420px;
  background: radial-gradient(
    circle,
    rgba(255,255,255,0.9),
    rgba(255,255,255,0.3),
    transparent 70%
  );
  filter: blur(100px);
  animation: bgFloat 14s ease-in-out infinite alternate;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
}

/* CARD */
.login-card {
  backdrop-filter: blur(18px);
  background: rgba(255,255,255,.9);
  border-radius: 24px;
  box-shadow: 0 25px 60px rgba(0,0,0,.25);
  padding: 40px 36px 30px;
  min-width: 360px;
  animation: cardEnter .9s cubic-bezier(.4,0,.2,1);
  z-index: 1;
}

/* HEADER */
.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-logo {
  width: 72px;
  margin-bottom: 14px;
  animation: float 4s ease-in-out infinite;
}

/* APP INFO */
.app-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.app-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: .4px;
}

.app-meta {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
}

.app-version {
  font-size: 12px;
  color: #6b7280;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1f5f9;
}

.app-dev {
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  padding: 2px 8px;
  border-radius: 999px;
  animation: pulse 1.6s infinite;
}

/* WELCOME */
.login-welcome {
  font-size: 1.35rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  color: #1f2937;
}

/* FORM */
.login-form {
  width: 100%;
}

/* INPUT */
.ivu-input {
  border-radius: 14px !important;
  height: 46px;
  transition: box-shadow .25s ease, transform .2s ease;
}

.ivu-input:focus {
  transform: translateY(-1px);
  box-shadow: 0 0 0 3px rgba(99,102,241,.25);
}

.login-btn {
  height: 48px;
  font-size: 1.05rem;
  font-weight: 600;
  border-radius: 16px;
  background: linear-gradient(135deg, #6366f1, #3b82f6);
  box-shadow: 0 14px 30px rgba(59,130,246,.35);

  /* default text */
  color: #ffffff !important;
  transition: all .2s ease;
}

/* HOVER */
.login-btn:hover,
.login-btn:focus {
  color: #e0e7ff !important; /* putih kebiruan */
}

/* ACTIVE */
.login-btn:active {
  color: #c7d2fe !important;
}

/* ICON */
.login-btn i {
  color: inherit !important;
}

/* FOOTER */
.login-footer {
  margin-top: 18px;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

/* TRANSITION */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .4s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

/* ANIMATION */
@keyframes cardEnter {
  from { opacity: 0; transform: translateY(40px) scale(.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0); }
}

@keyframes bgFloat {
  from { transform: translateX(-50%) translateY(0); }
  to { transform: translateX(-50%) translateY(40px); }
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34,197,94,.7); }
  70% { box-shadow: 0 0 0 12px rgba(34,197,94,0); }
  100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
}

.captcha-wrapper {
  display: flex;
  justify-content: center;
  margin: 14px 0 18px;
  transform: scale(.95);
}

.logo-animated {
  position: relative;
  display: inline-block;
  animation: logoEnter 1s ease-out forwards;
}

/* LOGO */
.logo-static {
  display: inline-block;
}

/* LOGO IMAGE */
.logo-img {
  width: 160px;
  height: auto;
  display: block;

  /* clarity */
  image-rendering: -webkit-optimize-contrast;

  /* depth */
  filter:
    drop-shadow(0 2px 4px rgba(0,0,0,.25))
    drop-shadow(0 6px 16px rgba(0,0,0,.2));
}


/* SHINE EFFECT */
.logo-shine {
  position: absolute;
  top: 0;
  left: -50%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255,255,255,.6),
    transparent
  );
  transform: skewX(-20deg);
  animation: shineMove 3.5s ease-in-out infinite;
}

/* ENTRY */
@keyframes logoEnter {
  from {
    opacity: 0;
    transform: translateY(18px) scale(.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* FLOAT */
@keyframes logoFloat {
  0% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0); }
}

/* SHINE */
@keyframes shineMove {
  0% {
    left: -60%;
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  60% {
    left: 120%;
    opacity: 0;
  }
  100% {
    left: 120%;
    opacity: 0;
  }
}

</style>



// WEBPACK FOOTER //
// Login.vue?3c1c23f2